import React, { useEffect, useState } from 'react';
import { CircularProgress, IconButton, MenuItem, RaisedButton, SelectField, TableRowColumn } from 'material-ui';
import styled from 'styled-components';
import OpenUrl from 'material-ui/svg-icons/action/open-in-new';
import Done from 'material-ui/svg-icons/action/done-all';
import NotDone from 'material-ui/svg-icons/navigation/close';
import RefNosTooltip from './RefNosTooltip';

/**
 * 
 * @param {{
 *  item: import('./FailedToSent').FailedTwin & import('./FailedToSent').UpdateStatuses
 *  sendRequest: Function,
 *  itemIndex: number,
 * }} props  
 */
export default function FailedToSentRow({ item, sendRequest, itemIndex }) {
    const [elementTarget, setElementTarget] = useState(null);
    const [openRefNosTooltip, setOpenRefNosTooltip] = useState(false);
    const [status, setStatus] = useState(/** @type {'success' | 'error' | 'pending' | undefined } */(undefined));

    useEffect(() => {
        setStatus(item.status);
    }, [item.status]);

    const closeTooltip = () => {
        setOpenRefNosTooltip(false);  
    };

    const onRefNosClick = (event) => {
        setElementTarget(event.target);
        setOpenRefNosTooltip(true);
    };
    console.log(item);
    return (
        <React.Fragment>
            <RefNosTooltip 
                elementTarget={elementTarget}
                open={openRefNosTooltip}
                close={closeTooltip}
                refNos={item.refNos || []}
            />
            <StyledTableRowColumn title={item.subject} width={34}>
                { item.subject }
            </StyledTableRowColumn>
            <StyledTableRowColumn width={5}>
                <IconButton style={{ transform: 'translateY(10px)', display: 'flex', padding: 'unset' }}> 
                    <OpenUrl
                        onClick={() => window.open(`/${item._id}`, '_blank')}
                    />
                </IconButton>
            </StyledTableRowColumn>
            <StyledTableRowColumn width={15}>
                {item.context.mailGateEmail}
            </StyledTableRowColumn>
            <StyledTableRowColumn width={15}>
                {item.realUserEmail || null}
            </StyledTableRowColumn>
            <StyledTableRowColumn width={15}>
                {
                    item.refNos && item.refNos.length && status === 'success' ?
                        <StyledShow onClick={e => onRefNosClick(e)}>Show</StyledShow>
                        : null
                }
            </StyledTableRowColumn>
            <StyledTableRowColumn width={5} nop style={{ textAlign: 'center' }}>
                { status === 'pending' ? <CircularProgress size={20} /> : null }
                { status === 'success' ? <StyledDone color='green' /> : null }
                { status === 'error' ? <StyledNotDone color='red' /> : null }
            </StyledTableRowColumn>
            <StyledTableRowColumn width={11}>
                <RaisedButton 
                    label='Send'
                    secondary
                    onClick={() => sendRequest(itemIndex)}
                />
            </StyledTableRowColumn>
        </React.Fragment>
    );
}

const StyledTableRowColumn = styled(TableRowColumn)`
    width: ${props => props.width + '%'};
    padding-left: ${props => (props.nop ? 'unset' : '24px')} !important;
    padding-right: ${props => (props.nop ? 'unset' : '24px')} !important;
`;

const StyledDone = styled(Done)`
    padding-left: 12px;
    width: 36px !important;
`;

const StyledNotDone = styled(NotDone)`
    padding-left: 12px;
    width: 36px !important;
`;

const StyledShow = styled.span`
    color: gray;
    text-decoration: underline;
    cursor: pointer;
`;



// WEBPACK FOOTER //
// ./app/components/Letters/common/FailedToSentRow.jsx